import { GetterTree } from 'vuex';
import { RootState } from '@/store';
import { ManagerState } from '@/store/modules/manager/index';
import { OfficesModel } from '@/models/Offices.model';
import {
  APPROVE_FORM_ERRORS,
  CAN_APPROVE,
  CAN_REJECT,
  CUBE,
  CUBE_DETAILS,
  CUBE_DETAILS_ERRORS,
  CUBE_SEARCH_OBJECT,
  CUBES_INFO,
  CUBES_INFO_ERRORS,
  CUBES_STATS,
  CUBES_STATS_ERRORS,
  CUBES_STATS_LOADING,
  EMPLOYEE_EMAIL,
  FORM101_CHANGES,
  FORM101_OFFICES_LIST,
  FORM101_SECTION_NAMES,
  FORM101_SECTION_NOTES,
  FORM101_UNITS_LIST,
  FORM101_UNITS_LIST_LOADING,
  FORM_101_CHANGES_NOTES_ERRORS,
  FORM_101_FILTERS_LIST,
  FORM_101_REJECT_REASON,
  FORM_101_STATUSES_LIST,
  FORM_STATUS_HISTORY,
  FORMS_RESULT_DATA,
  FORMS_SEARCH_ERRORS,
  FORMS_SEARCH_FILTERS,
  FORMS_SEARCH_OBJECT,
  ID_NUMBER_FIELDS_DATA,
  MANAGER_LOADING,
  MANAGER_MODE,
  MANUAL_FORM,
  MANUAL_UPDATE_IPT_MODAL_ERRORS,
  MASKIT_MODE,
  ADP_MODE,
  OPEN_APPROVE_FORMS_MODAL,
  OPEN_APPROVE_FORMS_MODAL_ERRORS,
  OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL,
  OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL_ERRORS,
  OPEN_MANUAL_FORM_MODAL,
  OPEN_MANUAL_UPDATE_IPT_MODAL,
  OPEN_REMOVE_FORM_MODAL,
  OPEN_REMOVE_FORM_MODAL_ERRORS,
  REJECT_FORM_ERRORS,
  RESET_PASSWORD_LOADING,
  SEARCH_EMPLOYEES_CURRENT_FORM,
  SELECTED_FORMS_TO_APPROVE,
  STATISTICS,
  STATISTICS_ERRORS,
  STATISTICS_OFFICES,
  STATUS_DESC,
} from '@/types/managerForm.types';
import { UnitsModel } from '@/models/Units.model';
import { Form101SearchModel } from '@/models/Form101Search.model';
import { Grid } from '@/models/Grid.model';
import { Form101StatisticsModel } from '@/models/manager/Form101Statistics.model';
import { CodeTable } from '@/models/base/CodeTable.interface';
import { ManagerForm101Data } from '@/models/manager/ManagerForm101Data.model';
import { CubesInfoModel } from '@/models/manager/CubesInfo.model';
import { ApproveFormRequest } from '@/models/manager/ApproveFormRequest';
import { Document } from '@/models/form/Documents.model';
import { GetIdNumberFieldsResponseModel } from '@/models/manager/GetIdNumberFieldsResponse.model';
import { FormsSearchFilters } from '@/models/manager/forms-search-filters';
import { CubesStatsModel } from '@/models/manager/CubesStats.model';

export const getters: GetterTree<ManagerState, RootState> = {

  [FORM101_OFFICES_LIST](state): OfficesModel[] {
    return state.offices;
  },

  [FORM101_UNITS_LIST](state): UnitsModel[] {
    return state.units;
  },

  [FORM101_UNITS_LIST_LOADING](state): boolean {
    return state.form101UnitsListLoading;
  },

  [FORMS_SEARCH_OBJECT](state): Form101SearchModel {
    return state.form101SearchObject;
  },

  [FORMS_SEARCH_FILTERS](state): FormsSearchFilters[] {
    return state.formsSearchFilters;
  },

  [FORMS_RESULT_DATA](state): Grid {
    return state.formsResultData;
  },

  [FORMS_SEARCH_ERRORS](state): string[] {
    return state.formsSearchErrors;
  },

  [STATISTICS](state): Form101StatisticsModel[] {
    return state.statistics;
  },

  [STATISTICS_ERRORS](state): any {
    return state.statisticsErrors;
  },

  [STATISTICS_OFFICES](state): OfficesModel[] {
    return state.statisticsOffices;
  },

  [MANAGER_MODE](state): boolean {
    return state.managerMode;
  },

  [MANAGER_LOADING](state): boolean {
    return state.managerLoading;
  },

  [FORM_STATUS_HISTORY](state): Grid {
    return state.formStatusHistory;
  },

  [FORM101_CHANGES](state): Grid {
    return state.form101Changes;
  },

  [FORM101_SECTION_NAMES](state): Grid {
    return state.form101SectionNames;
  },

  [FORM101_SECTION_NOTES](state): object {
    return state.form101SectionNotes;
  },

  [APPROVE_FORM_ERRORS](state): string[] {
    return state.approveFormErrors;
  },

  [REJECT_FORM_ERRORS](state): string[] {
    return state.rejectFormErrors;
  }
  ,
  [OPEN_REMOVE_FORM_MODAL](state): boolean {
    return state.openRemoveFormModal;
  }
  ,
  [OPEN_REMOVE_FORM_MODAL_ERRORS](state): string[] {
    return state.openRemoveFormModalErrors;
  },

  [FORM_101_CHANGES_NOTES_ERRORS](state): string[] {
    return state.form101ChangesNotesErrors;
  },

  [FORM_101_STATUSES_LIST](state): CodeTable[] {
    return state.form101StatusesList;
  },

  [SEARCH_EMPLOYEES_CURRENT_FORM](state): ManagerForm101Data {
    return state.searchEmployeesCurrentForm;
  },

  [OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL](state): boolean {
    return state.openManagerFormResetPasswordModal;
  },

  [OPEN_MANAGER_FORM_RESET_PASSWORD_MODAL_ERRORS](state): string[] {
    return state.openManagerFormResetPasswordModalErrors;
  },

  [EMPLOYEE_EMAIL](state): string {
    return state.employeeEmail;
  },

  [CUBES_INFO](state): CubesInfoModel[] {
    return state.cubesInfo;
  },

  [CUBES_INFO_ERRORS](state): string[] {
    return state.cubesInfoErrors;
  },

  [CUBE_DETAILS](state): Grid {
    return state.cubeDetails;
  },

  [CUBE_DETAILS_ERRORS](state): string[] {
    return state.cubeDetailsErrors;
  },

  [MASKIT_MODE](state): boolean {
    return state.maskitMode;
  },

  [ADP_MODE](state): boolean {
    return state.adpMode;
  },

  [OPEN_APPROVE_FORMS_MODAL](state): boolean {
    return state.openApproveFormsModal;
  },

  [OPEN_APPROVE_FORMS_MODAL_ERRORS](state): string[] {
    return state.openApproveFormsModalErrors;
  },

  [SELECTED_FORMS_TO_APPROVE](state): ApproveFormRequest[] {
    return state.selectedFormsToApprove;
  },

  [MANUAL_FORM](state): Document[] {
    return state.manualForms;
  },

  [ID_NUMBER_FIELDS_DATA](state): GetIdNumberFieldsResponseModel {
    return state.idNumberFields;
  },

  [CAN_APPROVE](state): boolean {
    return state.canApprove;
  },

  [CAN_REJECT](state): boolean {
    return state.canReject;
  },

  [STATUS_DESC](state): string {
    return state.statusDesc;
  },

  [OPEN_MANUAL_FORM_MODAL](state): boolean {
    return state.openManualFormModal;
  },

  [FORM_101_REJECT_REASON](state): string {
    return state.form101RejectReason;
  },

  [FORM_101_FILTERS_LIST](state): any[] {
    return state.form101Filters;
  },

  [CUBE](state): CubesInfoModel {
    return state.cube;
  },

  [CUBE_SEARCH_OBJECT](state): Form101SearchModel {
    return state.cubeSearchObject;
  },

  [RESET_PASSWORD_LOADING](state): boolean {
    return state.resetPasswordLoading;
  },

  [CUBES_STATS](state): CubesStatsModel {
    return state.cubesStats;
  },

  [CUBES_STATS_ERRORS](state): string[] {
    return state.cubesStatsErrors;
  },

  [CUBES_STATS_LOADING](state): boolean {
    return state.cubesStatsLoading;
  },

  [OPEN_MANUAL_UPDATE_IPT_MODAL](state): boolean {
    return state.openManualUpdateIptModal;
  },

  [MANUAL_UPDATE_IPT_MODAL_ERRORS](state): string[] {
    return state.manualUpdateIptModalErrors;
  },

};
